<template>
    <div
        class="md-video layout1 mg-bg"
        :class="{
            'mg-container': !fullColumn,
            'mobile-no-margin': true,  
        }"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <div class="f-col">
            <div class="title-wrap" v-animated="{name: 'appear-down', enable: showAnimationEffects}">
                <site-title
                    class="title-uppercase"
                    :title="title"
                    :align="align"
                />
                <site-p
                    class="desc"
                    :text="desc"
                    :size="16"
                    :align="align"
                    :mbSize="16"
                />
            </div>
            <div
                class="video-content"
                @click="contentClick"
            >
                <banner-video
                    v-if="videoOption?.src || videoOption?.previewSrc"
                    ref="bannerVideo"
                    :key="videoKey"
                    :src="videoOption?.src"
                    :previewSrc="videoOption?.previewSrc"
                    isContain
                    :option="option"
                />
                <div v-else class="banner-video defalt-wrap">
                    <site-img :src="videoIconSrc" dir="width" />
                </div>
                <div
                    v-if="maskOption && maskOption.showMask"
                    class="mask"
                    :style="{ backgroundColor: maskOption.maskColor }"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index-layout';
import util from '../../../common/util';

export default {
    mixins: [common],
    data: function() {
        return {
            videoKey: new Date().getTime(),
            noVideoImg: 'https://cdn.chime.me/image/fs/sitebuild/2024418/5/original_7152253e-20f2-4ff5-802b-6e894b01c2d3.png',
            videoIconSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/md-video/video-icon.png'
        };
    },
    computed: {
        option({ videoOption }) {
            return {
                ... videoOption,
                autoHeight: false,
                playInline: true,
            }
        }
    },
    watch: {
        videoOption() {
            this.videoKey = new Date().getTime();
        }
    },
    methods: {
        contentClick(evt) {
            if (!this.platform.isMobile) {
                const bannerVideoVm = this.$refs.bannerVideo;
                const target = evt.target;
                if (
                    util.closest(target, 'video') &&
                    this.videoOption.showProgress
                ) {
                    return; 
                }
                if (bannerVideoVm && !bannerVideoVm.isPause) {
                    this.doVideoPause();
                } else if (bannerVideoVm) {
                    this.doVideoPlay();
                }
            }
        },
        doVideoPlay() {
            this.$refs.bannerVideo && this.$refs.bannerVideo.doPlay();
        },
        doVideoPause() {
            this.$refs.bannerVideo && this.$refs.bannerVideo.doPause();
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-video.layout1 {
    .title-uppercase{
        text-transform: uppercase;
        margin-bottom: 15px;
        @include media-600 {
            margin-bottom: 10px;
        }
    }
    .video-content {
        width: 100%;
        margin-top: 40px;
        position: relative;
        padding-top: 44.8%;
        .mask {
            position: absolute;
            background: #DADADA;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            pointer-events: none;
            object-fit: none;
            object-position: center;
        }
        .banner-video.is-play ~ .mask {
            display: none;
        }
        .banner-video {
            &.defalt-wrap {
                background: rgba(218, 218, 218, 0.3);
                img {
                    width: 100px;
                    height: 87.5px;
                    opacity: 0.3;
                }
            }
            .play-video{
                border-width: 1px;
                width: 64px;
                height: 64px;
                &:after{
                    left: 27px;
                    border-top: 8px solid transparent;
                    border-bottom: 8px solid transparent;
                    border-left: 14px solid white;
                }

                @include media-600 {
                    width: 40px;
                    height: 40px;
                    &:after{
                        left: 15px;
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid transparent;
                        border-left: 9px solid white;
                    }
                }
            }
        }
    }
    
    @include media-600 {
        .desc {
            font-size: 14px;
            line-height: 1.43;
        }
        .video-content {
            margin-top: 20px;
            .banner-video {
                &.defalt-wrap {
                    img {
                        width: 50px;
                        height: 44px;
                    }
                }
            }
        }
    }
}
</style>
